<template>
  <template v-if="!isLoadError">
    <register-form @submit.prevent="showConfirmModal">
      <form-caption v-if="pageTitle" :text="pageTitle" />
      <vuex-hidden-form-item bind="uuid" />
      <text-browse-item label="仲介業者" :value="companyName" />
      <vuex-text-form-item label="氏名" bind="name" :required="true" />
      <vuex-text-form-item label="氏名（カナ）" bind="name_kana" :required="true" />
      <text-browse-item label="メールアドレス" :value="email" />
      <vuex-password-form-item label="パスワード" bind="password" :required="true" />
      <vuex-switch-form-item label="２段階認証" bind="use_two_step_authentication" />
      <vuex-textarea-form-item label="連絡先" bind="contact" />
      <vuex-text-form-item label="店舗名" bind="office" />
      <vuex-text-form-item label="部署名" bind="department" />
    </register-form>
    <teleport to="body">
      <register-confirm-modal ref="confirmModal" @register="doRegister" />
    </teleport>
  </template>
  <template v-else>
    <plain-form>
      <div v-if="isLoadErrorConflict">
        <p>既に登録済みのメールアドレスです。</p>
      </div>
      <div v-else-if="isLoadErrorGone">
        <p>URLの有効期限が過ぎました。</p>
        <p>招待者に再度招待するよう依頼してください</p>
      </div>
    </plain-form>
  </template>
</template>

<script>
import {mapState} from "vuex";
import RegisterForm from "@/views/templates/forms/RegisterForm";
import FormCaption from '@/views/atoms/FormCaption'
import VuexHiddenFormItem from "@/views/molecules/formItems/VuexHiddenFormItem";
import TextBrowseItem from "@/views/molecules/browseItems/TextBrowseItem";
import VuexTextFormItem from "@/views/molecules/formItems/VuexTextFormItem";
import VuexPasswordFormItem from "@/views/molecules/formItems/VuexPasswordFormItem";
import VuexTextareaFormItem from "@/views/molecules/formItems/VuexTextareaFormItem";
import RegisterConfirmModal from "@/views/molecules/modals/RegisterConfirmModal";
import PlainForm from '@/views/templates/forms/PlainForm';
import VuexSwitchFormItem from "@/views/molecules/formItems/VuexSwitchFormItem";

export default {
  name: "RegistrationInvitedRegister",
  components: {
    RegisterForm,
    FormCaption,
    VuexHiddenFormItem,
    TextBrowseItem,
    VuexTextFormItem,
    VuexPasswordFormItem,
    VuexTextareaFormItem,
    RegisterConfirmModal,
    PlainForm,
    VuexSwitchFormItem,
  },
  provide: {
    bindModule: 'broker_register_form'
  },
  computed: {
    ...mapState('broker_register_form', {
      companyName: state => state.data.company.name,
      email: state => state.data.email,
      isLoadErrorConflict: state => state.isLoadErrorConflict,
      isLoadErrorGone: state => state.isLoadErrorGone,
    }),
    pageTitle() {
      return this.$store.state.pageTitle;
    },
    isLoadError() {
      return this.isLoadErrorConflict || this.isLoadErrorGone;
    },
  },
  mounted() {
    this.$store.dispatch('startPageLoading').then(() => {
      return this.$store.dispatch('broker_register_form/load', {
        uuid: this.$route.query.uuid
      });
    }).catch(reason => this.$root.failApi(reason)).finally(() => this.$store.dispatch('stopPageLoading'));
  },
  methods: {
    showConfirmModal() {
      this.$refs.confirmModal.show();
    },
    doRegister() {
      this.$store.dispatch('broker_register_form/register').then(() => {
        this.$router.push({name: 'Login'});
      }).catch(reason => this.$root.failApi(reason));
    }
  },
}
</script>
